import { render, staticRenderFns } from "./newRepotGlobal.vue?vue&type=template&id=44bc6f1c"
import script from "./newRepotGlobal.vue?vue&type=script&lang=js"
export * from "./newRepotGlobal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports